import BoldText from '@/components/BoldText';
import { capitalizeFirstLetter } from '@/helpers/string';
import { IResponseApi } from '@/types/apis/response';
import { Card, SkeletonBodyText, Text } from '@shopify/polaris';
import { DonutChart, PolarisVizProvider } from '@shopify/polaris-viz';
import { memo, useMemo } from 'react';
interface IProps {
  data?: IResponseApi.IGetDashboardSummary;
  isLoading: boolean;
}
const CustomDonutChart = ({ data, isLoading }: IProps) => {
  const dataChart = useMemo(() => {
    if (data) {
      const listKey = data.data?.topChannels?.categories;
      const objectChart: { [key: string]: number[] } = {};
      listKey.forEach((key, index) => {
        const totalClicks = data.data?.topChannels?.desktopClicks[index] + data.data?.topChannels?.mobileClicks[index];
        objectChart[key] = [totalClicks ?? 0];
      });
      const colors = ['#ff97af', '#ffd18c', '#bbd18b', '#9ad3ff'];
      const categories = data.data?.topChannels?.categories;
      const result = Object.entries(objectChart).map(([_, value], index) => {
        return {
          name: capitalizeFirstLetter(listKey[index]),
          color: colors[index],
          data: value.map((value, i) => {
            return {
              value,
              key: categories[i],
            };
          }),
        };
      });
      return result;
    }
    return [];
  }, [data]);

  return (
    <Card>
      {data?.data.summary.clicks && data?.data.summary.clicks > 0 ? (
        <PolarisVizProvider>
          <div style={{ height: 420, marginTop: '1rem' }}>
            {isLoading ? <SkeletonBodyText lines={20} /> : <DonutChart theme="Light" data={dataChart} legendPosition="bottom" />}
          </div>
        </PolarisVizProvider>
      ) : (
        <div style={{ height: 420, marginTop: '1rem' }} className="flex-center">
          <div className="flex-center" style={{ flexWrap: 'wrap', justifyContent: 'center' }}>
            <BoldText>Nothing to see here yet!</BoldText>
            <div className="mt-8">
              <Text as="p" alignment="center">
                When someone clicks any button, the details will appear here.
              </Text>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
};

export default memo(CustomDonutChart);
